import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import classNames from 'classnames'
import Modal from '../../modal'
import Button from '../../../baseComponent/button'
import './index.less'

export default (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<VersionNumber {...props} visible container={div} />, div)
  })
}

export const VersionNumber = ({ visible, onCancel, onOk, title }) => {
  const [_visible, set_Visible] = useState(visible)
  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }
  const _ok = async () => {
    const flag = await onOk?.()
    if (flag === false) {
      return
    }
    set_Visible(false)
  }
  return <Modal
    style={{ width: '720px' }}
    visible={_visible}
    onCancel={_cancel}
    onOk={_ok}
    hiddenFooter
  >
    <div className="mn-public-component-fun-modal-version-number">
      <div className="mn-public-component-fun-modal-version-number-title">{title}数量已满，请联系您的销售经理升级专业版后继续</div>
      <div className="mn-public-component-fun-modal-version-number-sub-title">升级除了可以无限灵感集外，还可立即享有更多特权</div>
      <div className="mn-public-component-fun-modal-version-number-content">
        <div className="mn-public-component-fun-modal-version-number-content-left">
          <div className={classNames('mn-public-component-fun-modal-version-number-version-title', { professional: true })}>专业版</div>
          <div className="mn-public-component-fun-modal-version-number-wrap">
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>灵感集</div>
              <div className="professional-limit">不限</div>
            </div>
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>子灵感集</div>
              <div className="professional-limit">不限</div>
            </div>
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>款式下载</div>
              <div className="professional-limit">不限</div>
            </div>
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>批量下载</div>
              <div className="professional-limit">不限</div>
            </div>
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>报表导出</div>
              <div className="professional-limit">不限</div>
            </div>
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>智能打标</div>
              <div className="professional-limit">不限</div>
            </div>
            <div style={{ textAlign: 'center', marginTop: '32px' }}>
              <Button
                type="normal"
                onClick={() => {
                  set_Visible(false)
                  window.open('/meinian/home/version', '_self')
                }}
              >查看更多版本权益</Button>
            </div>
          </div>
        </div>
        <div className="mn-public-component-fun-modal-version-number-content-right">
          <div className={classNames('mn-public-component-fun-modal-version-number-version-title', { basis: true })}>基础版</div>
          <div className="mn-public-component-fun-modal-version-number-wrap">
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>灵感集</div>
              <div className="basis-limit">20个</div>
            </div>
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>子灵感集</div>
              <div className="basis-limit">5个/单个灵感集</div>
            </div>
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>款式下载</div>
              <div className="basis-limit">200个/天</div>
            </div>
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>批量下载</div>
              <div className="basis-limit">50个/次</div>
            </div>
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>报表导出</div>
              <div className="basis-limit">5次/天</div>
            </div>
            <div className="mn-public-component-fun-modal-version-number-item">
              <div>智能打标</div>
              <div className="basis-limit">20张/天</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
}
